export default __webpack_public_path__ + "static/media/CIA-Consent-Credit-Check-Financial-Risk-Survey.988aac0f.pdf";